import { css } from '@emotion/react';

import partyImage from 'src/assets/jpg/hos-party.jpg';
import { getTheme } from 'src/utils/getTheme';

const { theme } = getTheme();

export const styles = {
    container: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    }),

    topWrapper: css({
        width: '100%',
        height: '100%',
        padding: '50px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: 'white',
        background: theme.palette.secondary.dark,
    }),

    image: css({
        [theme.breakpoints.down('lg')]: {
            width: '458px',
            height: '223px',
        },
        [theme.breakpoints.down('md')]: {
            width: '353px',
            height: '172px',
        },
    }),

    titleWrapper: css({
        position: 'relative',
        display: 'inline-block',
        textAlign: 'center',
        marginBottom: '70px',
        marginTop: '-20px',
    }),

    circle: css({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%) rotate(-18.555deg)',
        border: `1px solid ${theme.palette.primary.dark}`,
        width: '332px',
        height: '102px',
        borderRadius: '200%',
        zIndex: 0,
        [theme.breakpoints.down('lg')]: {
            width: '261px',
            height: '88px',
        },
    }),

    title: css({
        position: 'relative',
        zIndex: 1,
    }),

    bottomWrapper: css({
        width: '100%',
        height: '690px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `url(${partyImage})`,
        backgroundPosition: '30% 20%',
        backgroundSize: 'cover',
    }),

    logo: css({
        display: 'block',
        width: '107px',
        height: '107px',
        [theme.breakpoints.down('lg')]: {
            width: '62px',
            height: '62px',
        },
    }),

    cta: css({
        display: 'flex',
        height: '45px',
        padding: '16px 16px 12px 16px',
        marginTop: '30px',
        justifyContent: 'center',
        gap: '30px',
        alignItems: 'stretch',
        borderRadius: '100px',
        paddingBlock: '16px',
        width: '100%',
        alignSelf: 'stretch',
        textTransform: 'none',
        [theme.breakpoints.up('lg')]: {
            width: '186px',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
        '&:hover': {
            border: `1px solid ${theme.palette.primary.main}`,
        },
    }),
};
